import { SeasonsQuery } from "~graphql/sdk";

export const remainingEventsForSeason = (
  events: SeasonsQuery["seasons"][number]["events"],
  isAdmin = false
) => {
  const now = new Date();
  const remaining = events.filter(
    (e) => new Date(e.startDate) > now && (isAdmin || e.isActive)
  );

  return remaining;
};
